// extracted by mini-css-extract-plugin
module.exports = {"link":"LogoLink_link__-JMAG"};